var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9692 17.2188C38.9692 11.722 34.4972 7.25 29.0005 7.25C23.5037 7.25 19.0317 11.722 19.0317 17.2188C19.0317 22.7155 23.5037 27.1875 29.0005 27.1875C34.4972 27.1875 38.9692 22.7156 38.9692 17.2188ZM22.6567 17.2188C22.6567 13.7209 25.5026 10.875 29.0005 10.875C32.4984 10.875 35.3442 13.7209 35.3442 17.2188C35.3442 20.7166 32.4984 23.5625 29.0005 23.5625C25.5026 23.5625 22.6567 20.7168 22.6567 17.2188Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9123 55.635L50.6623 32.9788C50.4711 32.3813 49.9844 31.925 49.3756 31.7728L41.989 29.9266C44.4002 25.933 46.2173 21.5022 46.2173 17.2187C46.2173 7.72429 38.493 0 28.9986 0C19.5042 0 11.7799 7.72429 11.7799 17.2187C11.7799 21.5022 13.597 25.933 16.0082 29.9266L8.62161 31.7728C8.01284 31.925 7.52607 32.3813 7.33486 32.9788L0.084871 55.635C-0.115636 56.2614 0.0389922 56.9472 0.488718 57.4269C0.938443 57.9067 1.61281 58.1052 2.25069 57.9459L16.2799 54.4386L28.5006 57.9302C28.8261 58.0232 29.171 58.0232 29.4965 57.9302L41.7172 54.4386L55.7464 57.9459C55.8921 57.9822 56.0396 58 56.1859 58C56.6805 58 57.1614 57.7971 57.5084 57.4269C57.9583 56.9471 58.1128 56.2614 57.9123 55.635ZM27.1861 43.3948V53.7846L18.3649 51.2642L20.8062 36.6139C23.5027 39.8758 26.0431 42.3338 27.1861 43.3948ZM30.8111 43.3948C31.9542 42.3338 34.4945 39.8758 37.191 36.6139L39.6323 51.2642L30.8111 53.7846V43.3948ZM28.9986 3.62499C36.4942 3.62499 42.5923 9.72314 42.5923 17.2187C42.5923 26.1916 32.5208 36.7084 28.9979 40.1121C25.4734 36.7105 15.4049 26.2052 15.4049 17.2187C15.4049 9.72314 21.503 3.62499 28.9986 3.62499ZM10.4799 35.045L17.6933 33.242L14.7187 51.0922L4.52956 53.6395L10.4799 35.045ZM43.2786 51.0922L40.304 33.242L47.5174 35.045L53.4678 53.6396L43.2786 51.0922Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white",
    transform: "translate(0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon_map.2b8d01ae.svg";
export { ForwardRef as ReactComponent };